import React from 'react'
import MDSpinner from 'react-md-spinner'
import {withEither} from './HOCs'

const Spinner = () => (
  <div className="spinner center-block">
    <MDSpinner
      size="80"
      duration={3000}
      color1="#fc690a"
      color2="#fc690a"
      color3="#fc690a"
    />
  </div>
)

const isLoading = props => props.isLoading === true

const withSpinner = () => withEither(isLoading, Spinner)

export {Spinner, withSpinner}



// WEBPACK FOOTER //
// ./src/components/shared/Spinner.js